const ListingsCount = ({
    numTotalListings = 0,
    totalListingCount = 0,
    unarchivedListingCount = 0,
    archivedListingCount = 0,
    isPartialResponse = false,
} = {}) => ({
    numTotalListings: Number(numTotalListings),
    totalListingCount: Number(totalListingCount),
    unarchivedListingCount: Number(unarchivedListingCount),
    archivedListingCount: Number(archivedListingCount),
    isPartialResponse: Boolean(isPartialResponse),
});

export default ListingsCount;
